import { createTheme } from '@mui/material/styles';
import shippoTheme from '../styles/shippoTheme.js';

const menuTheme = createTheme(shippoTheme, {
    components: {
        MuiMenu: {
            styleOverrides: {
                list: {
                    paddingTop: 0,
                    paddingBottom: 0,
                },
            },
        },
    },
});

export { menuTheme as default };
//# sourceMappingURL=Menu.theme.js.map
